import { Box, Container, Row, Column, FooterLink } from "./FooterStyles";
import React, { useEffect, useState } from "react";

import "../styles/home.scss";

const Linkmenu = () => {
  return (
    <Column
      style={{
        position: "relative",
        left: window.innerWidth > 416 ? 0 : -20,
        textAlign: window.innerWidth > 416 ? "left" : "center",
      }}
    >
      <FooterLink href="/categories/coiffure">Coiffure</FooterLink>
      <FooterLink href="/categories/barber">Barber</FooterLink>
      <FooterLink href="/categories/onglerie">Onglerie</FooterLink>
      <FooterLink href="/categories/beaute">Institut de beauté</FooterLink>
      <FooterLink href="/categories/bien-etre">Bien Être</FooterLink>
    </Column>
  );
};

const Footer = () => {
  const [apropos, setApropos] = useState(false);
  const [decover, setDevover] = useState(false);
  const [size, setSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });
  useEffect(() => {
    const handleResize = () => {
      setSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <>
      {size.width >= 1112 ? (
        <>
          <Box
            style={{
              backgroundColor: "#F1F1F1",
            }}
          >
            <Container
              style={{
                width: size.width <= 1300 ? "96%" : "80%",
                maxWidth: 1920,
              }}
            >
              <Row className="customfooter">
                <Column
                  style={{
                    position: "relative",
                    marginLeft: window.innerWidth > 320 ? "0px" : null,
                    left: window.innerWidth > 320 ? 0 : -20,
                    justifyContent: "center",
                  }}
                >
                  <img
                    src={process.env.PUBLIC_URL + "/logo.png"}
                    alt="logo"
                    style={{ width: 214, alignSelf: "center" }}
                  />
                </Column>

                {window.innerWidth <= 416 && <Linkmenu />}
                <Column
                  style={{
                    position: "relative",
                    left: window.innerWidth > 416 ? 0 : -20,
                    textAlign: window.innerWidth > 416 ? "left" : "center",
                  }}
                >
                  <FooterLink href="/pro">
                    Ajouter votre établissement
                  </FooterLink>
                  {/* <FooterLink href="/apropos">A propos</FooterLink> */}
                  <FooterLink href="/cgu">CGU</FooterLink>
                  <FooterLink href="/privacy">Confidentialité</FooterLink>
                  <FooterLink href="/mentions-legales">
                    Mentions légales
                  </FooterLink>
                </Column>
                {window.innerWidth > 416 && <Linkmenu />}

                <div
                  style={{
                    alignSelf: "center",
                    textAlign: "right",
                  }}
                >
                  <a
                    href
                    onClick={() => {
                      window.scrollTo(0, 0);
                    }}
                  >
                    <img
                      src={process.env.PUBLIC_URL + "/up.png"}
                      alt="up"
                      style={{ width: 16 }}
                    />
                  </a>
                </div>
              </Row>
            </Container>
          </Box>

          <div
            style={{
              flex: 1,
              flexDirection: "row",
              justifyContent: "space-between",
              display: "flex",
              width: "100%",
              backgroundColor: "#000",
              paddingLeft: "10%",
              paddingRight: "10%",
              paddingTop: "20px",
              paddingBottom: "20px",
              alignItems: "center",
            }}
          >
            <span
              style={{
                color: "white",
                flex: 6,
                textAlign: "center",
                marginLeft: "12.2%",
              }}
            >
              © On Fleek 2021 - Tous droits réservés. Développé par OMARSOFT
            </span>
            <span style={{ color: "white", flex: 1, textAlign: "center" }}>
              <a
                href="https://www.instagram.com/onfleek_reunion/"
                target="_blank"
                rel="noreferrer"
              >
                <img
                  src={process.env.PUBLIC_URL + "/instagram.png"}
                  alt="instagram"
                  style={{ height: "25px", paddingRight: "11px" }}
                />
              </a>
              <a
                href="https://www.facebook.com/On-Fleek-100488315825901"
                target="_blank"
                rel="noreferrer"
              >
                <img
                  src={process.env.PUBLIC_URL + "/facebook.png"}
                  alt="facebook"
                  style={{ height: "25px", paddingLeft: "11px" }}
                />
              </a>
            </span>
          </div>
        </>
      ) : (
        <div
          class="footer-mobileP"
          style={{
            width: size.width,
          }}
        >
          <div
            class="overlap-group2P"
            style={{
              width: size.width,
            }}
          >
            <div
              class="flex-rowP"
              style={{
                minWidth: size.width - 74,
              }}
            >
              <div class="logo-on-fleekP"></div>
              <div>
                <a
                  href="https://www.instagram.com/onfleek_reunion/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    alt=""
                    class="trac-228P"
                    src="https://anima-uploads.s3.amazonaws.com/projects/6232bd12a610d88f478643a7/releases/62347ef62464e4d56678e10d/img/trac--228@1x.png"
                  />
                </a>
                <a
                  href="https://www.facebook.com/On-Fleek-100488315825901"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    alt=""
                    class="trac-227P"
                    src="https://anima-uploads.s3.amazonaws.com/projects/6232bd12a610d88f478643a7/releases/62347ef62464e4d56678e10d/img/trac--227@1x.png"
                  />
                </a>
              </div>
            </div>
            <div
              class="composant-26-3P p---mobileP"
              style={{
                width: size.width - 74,
              }}
            >
              <div class="a-propos-footerP">
                <a
                  onClick={() => {
                    setApropos(!apropos);
                  }}
                  href
                >
                  <div class="overlap-groupP">
                    <div class="x-proP">A propos</div>
                    <img
                      alt=""
                      class="ligneP"
                      style={{
                        width: size.width - 74,
                      }}
                      src="https://anima-uploads.s3.amazonaws.com/projects/6232bd12a610d88f478643a7/releases/62347ef62464e4d56678e10d/img/ligne-6@1x.png"
                    />
                  </div>
                  <img
                    alt=""
                    class="trac-36P"
                    style={{
                      transform: !apropos ? "rotate(0deg)" : "rotate(180deg)",
                    }}
                    src="https://anima-uploads.s3.amazonaws.com/projects/6232bd12a610d88f478643a7/releases/62347ef62464e4d56678e10d/img/trac--36-7@1x.png"
                  />
                </a>
              </div>
              {apropos && (
                <>
                  <div class="ajouter-votre-tablissementP">
                    <a
                      href="/pro"
                      style={{ color: "#000", textDecoration: "none" }}
                    >
                      Ajouter votre établissement
                    </a>
                  </div>
                  <div class="composant-26-3-itemP">
                    <a
                      href="/cgu"
                      style={{ color: "#000", textDecoration: "none" }}
                    >
                      CGU
                    </a>
                  </div>
                  <div class="composant-26-3-itemP">
                    <a
                      href="/privacy"
                      style={{ color: "#000", textDecoration: "none" }}
                    >
                      Confidentialité
                    </a>
                  </div>
                  <div class="composant-26-3-itemP">
                    <a
                      href="/mentions-legales"
                      style={{ color: "#000", textDecoration: "none" }}
                    >
                      Mentions légales
                    </a>
                  </div>
                </>
              )}

              <div
                class="composant-25P"
                style={{
                  marginBottom: 7,
                }}
              >
                <a
                  onClick={() => {
                    setDevover(!decover);
                  }}
                  href
                >
                  <div class="overlap-groupP">
                    <div class="x-proP">Découvrez nos professionnels</div>
                    <img
                      alt=""
                      class="ligneP"
                      style={{
                        width: size.width - 74,
                      }}
                      src="https://anima-uploads.s3.amazonaws.com/projects/6232bd12a610d88f478643a7/releases/62347ef62464e4d56678e10d/img/ligne-6@1x.png"
                    />
                  </div>
                  <img
                    alt=""
                    style={{
                      transform: !decover ? "rotate(0deg)" : "rotate(180deg)",
                    }}
                    class="trac-221P"
                    src="https://anima-uploads.s3.amazonaws.com/projects/6232bd12a610d88f478643a7/releases/62347ef62464e4d56678e10d/img/trac--221@1x.png"
                  />
                </a>
              </div>
              {decover && (
                <>
                  <div class="composant-26-3-itemP">
                    <a
                      href="/categories/coiffure"
                      style={{ color: "#000", textDecoration: "none" }}
                    >
                      Coiffure
                    </a>
                  </div>

                  <div class="composant-26-3-itemP">
                    <a
                      href="/categories/barber"
                      style={{ color: "#000", textDecoration: "none" }}
                    >
                      Barber
                    </a>
                  </div>
                  <div class="composant-26-3-itemP">
                    <a
                      href="/categories/beaute"
                      style={{ color: "#000", textDecoration: "none" }}
                    >
                      Institut de beauté
                    </a>
                  </div>
                  <div class="composant-26-3-itemP">
                    <a
                      href="/categories/bien-etre"
                      style={{ color: "#000", textDecoration: "none" }}
                    >
                      Bien Être
                    </a>
                  </div>
                </>
              )}
            </div>
            <img
              alt=""
              class="trac-226P"
              src="https://anima-uploads.s3.amazonaws.com/projects/6232bd12a610d88f478643a7/releases/62347ef62464e4d56678e10d/img/trac--226@1x.png"
            />
          </div>
          <div
            class="infoP"
            style={{
              minWidth: size.width,
              justifyContent: "center",
              height: size.width === 360 && 50,
            }}
          >
            <p class="on-fleek-2021-toP">
              © On Fleek 2021 - Tous droits réservés. Développé par OMARSOFT
            </p>
          </div>
        </div>
      )}
    </>
  );
};
export default Footer;
